'use client';

import { use } from 'react';
import { AsyncAutocomplete } from '@ghosts-inc/design-system/components';
import { ALIGN_ADORNMENT_TOP } from '@/components/autocomplete-styles';
import { searchPlatforms } from '../../preferences/actions';
import { SearchItem } from '../../preferences/types';
import { StepContext } from './StepContext';

export const PlatformsStep = ({ initialValues }: { initialValues: SearchItem[] }): JSX.Element => {
  const { setIsDirty } = use(StepContext);

  return (
    <AsyncAutocomplete
      name="platforms"
      label="Where do you sell?"
      placeholder="Make a selection"
      data-testid="platforms-search"
      optionsFetcher={searchPlatforms}
      defaultValue={initialValues}
      onChange={() => setIsDirty(true)}
      showAllOptions
      multiple
      disableCloseOnSelect
      sx={ALIGN_ADORNMENT_TOP}
    />
  );
};
